import { Injectable, OnDestroy } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WakeLockService implements OnDestroy {
  private wakeLock: any = null;
  constructor() {
    document.addEventListener('visibilitychange', async () => {
      if (document.visibilityState === 'visible') {
        await this.requestWakeLock();
      }
    });
  }

  async requestWakeLock() {
    try {
      if ('wakeLock' in navigator) {
        this.wakeLock = await (navigator as any).wakeLock.request('screen');
        this.wakeLock.addEventListener('release', () => {
        });
      } else {
        console.warn('Wake Lock API not supported in this browser.');
      }
    } catch (err) {}
  }

  releaseWakeLock() {
    if (this.wakeLock) {
      this.wakeLock.release();
      this.wakeLock = null;
      console.log('Wake Lock manually released.');
    }
  }

  ngOnDestroy() {
    this.releaseWakeLock();
  }


}
